import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Gleap from 'gleap';

const useGleapContext = () => {
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.authReducer.isAuthenticated);
  const roles = useSelector((state) => state.authReducer.roles);
  const selectedCompany = useSelector((state) => state.companyReducer.selected);

  useEffect(() => {
    if (!isAuthenticated) return;
    try {
      Gleap.attachCustomData({
        route: location.pathname,
        companyId: selectedCompany?.id ? String(selectedCompany.id) : null,
        companyName: selectedCompany?.name || null,
        roles: Array.isArray(roles) ? roles.join(',') : '',
      });
    } catch (_) {
      // Gleap not initialized yet — ignore
    }
  }, [location.pathname, selectedCompany, roles, isAuthenticated]);
};

export default useGleapContext;
